<template>
    <div class="container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('failedActivations.searchTab')" name="search">
        <div class="filters">
            <!-- Arama Input -->
            <el-input v-model="searchQuery" placeholder="Search by Name, Phone, Serial Number..." clearable
                style="width: 300px; margin-right: 10px" @keyup.enter="handleSearch"></el-input>

            <el-button type="primary" @click="handleSearch">
                Search
            </el-button>
        </div>

        <!-- Kullanıcı Aktivasyon Tablosu -->
        <el-table :data="activations" v-loading="loading" style="margin-top: 20px" border>
            <!-- <el-table-column prop="id" label="ID" width="80"></el-table-column> -->
            <el-table-column prop="firstName" label="First Name" width="150"></el-table-column>
            <el-table-column prop="lastName" label="Last Name" width="150"></el-table-column>
            <el-table-column prop="phoneNumber" label="Phone" width="170"></el-table-column>
            <el-table-column prop="email" label="Email" width="250"></el-table-column>
            <el-table-column prop="caneSerialNumber" label="Serial Number" width="200"></el-table-column>
            <el-table-column prop="activationCode" label="Activation Code" width="140"></el-table-column>
             <el-table-column prop="address" label="Address" width="150"></el-table-column>
            <el-table-column prop="isActive" label="Is Active" width="70">
                <template #default="{row}">
                    <el-tag :type="row.isActive ? 'success' : 'danger'">
                        {{ row.isActive ? 'Active' : 'Inactive' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="Actions" width="100">
                <template #default="{row}">
                    <el-button type="primary" size="mini" @click="showDetails(row.id)">Details</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- Pagination -->
        <div class="pagination-wrapper" style="margin-top: 20px; display: flex; justify-content: flex-end;">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
            />
        </div>

        </el-tab-pane>

        <el-tab-pane name="failed">
          <span slot="label">
            {{ $t('failedActivations.tabLabel') }}
            <el-badge v-if="failedTotal > 0" :value="failedTotal" type="danger" style="margin-left: 6px" />
          </span>
          <div style="margin: 10px 0; color: #909399; font-size: 13px">
            {{ $t('failedActivations.description') }}
          </div>
          <div style="margin-bottom: 10px; display: flex; gap: 10px; align-items: center; flex-wrap: wrap">
            <el-input
              v-model="failedSearch"
              size="small"
              clearable
              :placeholder="$t('failedActivations.searchPlaceholder')"
              style="width: 320px"
              @keyup.enter.native="handleFailedSearch"
              @clear="handleFailedSearchClear"
            />
            <el-button size="small" type="primary" icon="el-icon-search" @click="handleFailedSearch">{{ $t('failedActivations.search') }}</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="fetchFailed">{{ $t('failedActivations.refresh') }}</el-button>
          </div>
          <el-table :data="failedActivations" v-loading="loadingFailed" border size="mini">
            <el-table-column prop="firstName" :label="$t('failedActivations.firstName')" width="130" />
            <el-table-column prop="lastName" :label="$t('failedActivations.lastName')" width="130" />
            <el-table-column prop="email" :label="$t('failedActivations.email')" width="230" show-overflow-tooltip />
            <el-table-column prop="serialNumber" :label="$t('failedActivations.caneSerial')" width="180" />
            <el-table-column prop="productType" :label="$t('failedActivations.type')" width="70" align="center" />
            <el-table-column :label="$t('failedActivations.issue')" width="200">
              <template #default="{row}">
                <el-tag v-if="row.deviceMissing" type="danger" size="mini">{{ $t('failedActivations.noDeviceRecord') }}</el-tag>
                <el-tag v-else-if="!row.deviceOwnerId" type="warning" size="mini">{{ $t('failedActivations.unowned') }}</el-tag>
                <el-tag v-else type="info" size="mini">{{ $t('failedActivations.boundToAnotherUser') }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="deviceOwnerEmail" :label="$t('failedActivations.deviceOwner')" width="220" show-overflow-tooltip>
              <template #default="{row}">{{ row.deviceOwnerEmail || '-' }}</template>
            </el-table-column>
            <el-table-column :label="$t('failedActivations.lostPermanentFeatures')" width="160" align="center">
              <template #default="{row}">
                <el-tag v-if="row.lostPermanentFeatures > 0" type="danger" size="mini">
                  {{ $tc('failedActivations.featureCount', row.lostPermanentFeatures, {n: row.lostPermanentFeatures}) }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('failedActivations.activation')" width="160">
              <template #default="{row}">{{ formatDate(row.completedAt) }}</template>
            </el-table-column>
            <el-table-column :label="$t('failedActivations.action')" width="200" align="center">
              <template #default="{row}">
                <el-tooltip
                  v-if="isPlaceholderSerial(row.serialNumber)"
                  :content="$t('failedActivations.brokenSerialTooltip')"
                  placement="top"
                >
                  <span>{{ $t('failedActivations.brokenSerial') }}</span>
                </el-tooltip>
                <el-button
                  v-else-if="!row.deviceOwnerId"
                  size="mini"
                  type="primary"
                  :loading="bindingKey === row.serialNumber + ':' + row.userId"
                  @click="bindRow(row)"
                >{{ $t('failedActivations.bindAndGrant') }}</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <template slot="empty">{{ $t('failedActivations.empty') }}</template>
          </el-table>
          <div style="margin-top: 15px; text-align: right">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :total="failedTotal"
              :page-size="failedPageSize"
              :page-sizes="[20, 50, 100, 200, 500]"
              :current-page="failedPage"
              @size-change="handleFailedPageSizeChange"
              @current-change="handleFailedPageChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>

        <!-- Aktivasyon Detayları Dialog -->
        <el-dialog title="Activation Versions" :visible.sync="detailsDialogVisible" width="60%">
            <el-table :data="activationVersions" v-loading="loadingDetails" border>
                <!-- <el-table-column prop="id" label="Version ID" width="150"></el-table-column> -->
                <el-table-column prop="mac" label="MAC Address" width="200"></el-table-column>
                <el-table-column prop="mainAppVersion" label="Main App Version" width="150"></el-table-column>
                <el-table-column prop="wirelessVersion" label="Wireless Version" width="150"></el-table-column>
                <el-table-column prop="fusVersion" label="FUS Version" width="150"></el-table-column>
                <el-table-column prop="appVersion" label="App Version" width="150"></el-table-column>
                <el-table-column prop="createdAt" label="Created At" width="200">
                    <template #default="{row}">
                        {{ formatDate(row.createdAt) }}
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <el-button @click="detailsDialogVisible = false">Close</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ActivationApi } from '@/wwapi/apis/activation-api' // Activation API sınıfını import et
import { getFailedActivations, bindFailedActivation } from '@/api/caneActivations'

export default {
  data() {
    return {
      searchQuery: '', // Arama metni
      filters: {
        isActive: null // Aktiflik filtresi
      },
      activations: [], // Aktivasyon listesi
      activationVersions: [], // Aktivasyon detayları
      loading: false, // Aktivasyon listesi yükleme durumu
      loadingDetails: false, // Aktivasyon detayları yükleme durumu
      detailsDialogVisible: false, // Detay dialog görünürlüğü
      // Pagination
      currentPage: 1,
      pageSize: 20,
      total: 0,
      // Sorunlu aktivasyonlar sekmesi
      activeTab: 'search',
      failedActivations: [],
      failedTotal: 0,
      failedPage: 1,
      failedPageSize: 50,
      failedSearch: '',
      bindingKey: null,
      loadingFailed: false
    }
  },
  created() {
    // Rozetteki sayı sekmeye girmeden de görünsün.
    this.fetchFailed()
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'failed' && this.failedActivations.length === 0) {
        this.fetchFailed()
      }
    },
    handleFailedSearch() {
      this.failedPage = 1
      this.fetchFailed()
    },
    handleFailedSearchClear() {
      this.failedSearch = ''
      this.failedPage = 1
      this.fetchFailed()
    },
    handleFailedPageSizeChange(size) {
      this.failedPageSize = size
      this.failedPage = 1
      this.fetchFailed()
    },
    handleFailedPageChange(page) {
      this.failedPage = page
      this.fetchFailed()
    },
    // Same rule as the backend's isPlaceholderCaneSerial: such a serial is
    // shared by unrelated canes, so binding it is refused.
    isPlaceholderSerial(serial) {
      if (typeof serial !== 'string') return true
      const value = serial.trim()
      if (value.length < 8) return true
      // eslint-disable-next-line no-control-regex
      if (/[\\\u0000-\u001f\u007f\ufffd]/.test(value)) return true
      return /^0+$/.test(value)
    },
    async bindRow(row) {
      try {
        await this.$confirm(
          this.$t('failedActivations.bindConfirm', { serial: row.serialNumber, email: row.email }),
          this.$t('failedActivations.bindTitle'),
          { confirmButtonText: this.$t('failedActivations.bind'), cancelButtonText: this.$t('failedActivations.cancel'), type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.bindingKey = row.serialNumber + ':' + row.userId
      try {
        const res = await bindFailedActivation({ serialNumber: row.serialNumber, userId: row.userId, version: row.version })
        const status = res && res.data && res.data.status
        // The API answers with the string 'success', not 200. Comparing against
        // 200 meant a successful bind fell into the error branch and showed
        // 'generic_success' in red, and fetchFailed() never ran so the row
        // stayed on screen although it had already been repaired.
        if (status && (status.code === 'success' || status.code === 200)) {
          this.$message.success(this.$t('failedActivations.bindSuccess'))
          this.fetchFailed()
        } else {
          this.$message.error((status && status.message) || this.$t('failedActivations.bindFailed'))
        }
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.status && e.response.data.status.message
        this.$message.error(msg || this.$t('failedActivations.bindFailed'))
      } finally {
        this.bindingKey = null
      }
    },
    async fetchFailed() {
      this.loadingFailed = true
      try {
        const res = await getFailedActivations({
          limit: this.failedPageSize,
          offset: (this.failedPage - 1) * this.failedPageSize,
          search: this.failedSearch ? this.failedSearch.trim() : undefined
        })
        const body = res && res.data && res.data.data
        this.failedActivations = (body && body.activations) || []
        this.failedTotal = (body && body.total) || 0
      } catch (e) {
        this.$message.error(this.$t('failedActivations.loadFailed'))
      } finally {
        this.loadingFailed = false
      }
    },
    // Search button clicked - reset to page 1
    handleSearch() {
      this.currentPage = 1
      this.fetchData()
    },
    // Page size changed
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.fetchData()
    },
    // Page changed
    handlePageChange(newPage) {
      this.currentPage = newPage
      this.fetchData()
    },
    // Aktivasyonları Getir
    async fetchData() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        this.activations = []
        this.total = 0
        return
      }

      this.loading = true
      const activationApi = new ActivationApi()
      try {
        const requestBody = {
          searchString: this.searchQuery,
          page: this.currentPage,
          limit: this.pageSize
        }
        const response = await activationApi.searchUserCaneActivations(requestBody)
        this.activations = response.data.data || []
        this.total = response.data.total || 0
      } catch (error) {
        console.error('Error fetching activations:', error)
        this.activations = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // Detayları Göster
    async showDetails(activationId) {
      this.loadingDetails = true
      this.detailsDialogVisible = true
      const activationApi = new ActivationApi()
      try {
        const response = await activationApi.getActivationVersions(activationId)
        this.activationVersions = response.data.data
      } catch (error) {
        console.error('Error fetching activation details:', error)
        this.activationVersions = []
      } finally {
        this.loadingDetails = false
      }
    },
    // Format date for display
    formatDate(dateStr) {
      if (!dateStr) return 'N/A'
      const date = new Date(dateStr)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${day}.${month}.${year} ${hours}:${minutes}`
    }
  },
  mounted() {
    // Don't fetch on mount - wait for user to enter search query
  }
}
</script>

<style lang="scss" scoped>
.container {
    padding: 20px;
}

.filters {
    display: flex;
    align-items: center;
}
</style>
